import './index.css'

import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Card, Col, Divider, FloatButton, Form, Input, Row, Typography, Upload, message } from "antd";

import { POST_API, POST_CATCH, getToken, getUPLOADAPI } from "../../services/hello-api";

import Pageload from "../../components/Pageload";
import { IoAddOutline, IoCameraOutline, IoPersonCircle } from "react-icons/io5";

class Timeline extends React.Component {

    state = { _loading: true, _navigate: false, data: [], _menu: false }

    componentDidMount = () => {
        this.onView()
    }

    onView = () => {
        this.setState({ _loading: true })
        POST_API('/timeline/search.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (!res.return) {
                this.setState({ _navigate: true })
            } else {
                this.setState({ data: res.data })
            }
        }).catch(() => POST_CATCH()).finally(() => {
            this.setState({ _loading: false })
        })
    }

    render = () => {

        const routes = [
            { title: <Typography className="page-bread active">Timeline</Typography> }
        ]

        if (this.state._navigate) return <Navigate to="/" />

        if (this.state._loading) return <Pageload />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to="novo"><FloatButton className="float-button add" icon={<IoAddOutline color="#FFF" size={25} />} /></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8, 8]}>
                        <Col span={24}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row gutter={[16, 16]}>
                        {this.state.data && this.state.data.map((v, i) => (
                            <Col span={24}>
                                <Card size={'small'}>
                                    <Row align={'middle'} style={{ marginBottom: 10 }}>
                                        {v.AVATAR ? <Avatar src={v.AVATAR} /> : <IoPersonCircle className="no-avatar" />}
                                        <Typography style={{ fontWeight: 600, marginLeft: 8 }}>{v.NICK ? v.NICK : v.NAME}</Typography>
                                    </Row>
                                    <img src={v.PHOTO} width={'100%'} />
                                    <Typography style={{ marginTop: 10 }}>{v.TEXTO ? v.TEXTO : ''}</Typography>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        )
    }

}

export default Timeline;